import SigliveServiceV1 from 'Service/sigliveServiceV1';

const deleteTalkingPoint = async ({ id }) => {
  const { data } = await SigliveServiceV1({ method: 'DELETE', url: `/briefs/talking-points/${id}` });

  return data;
};

export default deleteTalkingPoint;
